import {createCommand, LexicalCommand} from 'lexical';
import {LinkAttributes} from '@lexical/link';
import {Cell, InsertTableCommandPayload, Row} from './types';
import {emptyEditorJSON} from './constants';
import {v4 as uuidv4} from 'uuid';

export const SET_TEXT_COLOR: LexicalCommand<Record<'color', string> | void> = createCommand();

export const INSERT_COMMENT: LexicalCommand<void> = createCommand();

export const INSERT_TAB_SPACES: LexicalCommand<void> = createCommand();

export type EditLinkPayload = {
    url: string;
    text?: string;
    update?: boolean;
} & LinkAttributes;

export const ADD_LINK_COMMAND: LexicalCommand<EditLinkPayload | null> = createCommand();

export const OPEN_LINK_MODAL_COMMAND: LexicalCommand<null> = createCommand();

export const INSERT_TABLE_COMMAND: LexicalCommand<InsertTableCommandPayload> = createCommand();

export function createUID(): string {
    return Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 5);
}

export function createCell(type: 'normal' | 'header'): Cell {
    return {
        colSpan: 1,
        id: uuidv4(),
        json: emptyEditorJSON,
        type,
        width: null
    };
}

export function createRow(): Row {
    return {
        cells: [],
        height: null,
        id: uuidv4()
    };
}
